'use strict';

module.exports = function(ngModule) {
  console.log('Create Alert service');
  ngModule.factory('Alert', ['$rootScope', 'SiteVisitApi', 'localStorageService', function ($rootScope, SiteVisitApi, localStorageService) {
    var alerts=[];
    //Clears all alerts when route is changed
    $rootScope.$on("$locationChangeStart",function(event, next, current){
      alerts=[];
    });
    
    return {
      getAlerts: function(){
        return alerts;
      },
      addAlert: function(alertData) {
        console.log(alertData);
        alerts.push(alertData);
      },
      removeAlert: function(alert){
        var index = alerts.indexOf(alert);
        alerts.splice(index,1);
        if (alert.report) {
          SiteVisitApi.reportBug(
            JSON.parse(localStorageService.get('visitor')), 
            JSON.parse(localStorageService.get('case')), 
            JSON.parse(localStorageService.get('position')), 
            platform.description, 
            alert.message, 
            alert.appModule, 
            localStorageService.get('appName'), 
            localStorageService.get('appVersion')).then(
            function(data) {
              try {
                switch (data.status) {
                  case 'OK':
                    console.log('reportBug:', data);
                    alert.bugFiled = true;
                    break;
                  default:
                    console.log('reportBug:', data);
                }
              } catch(error) {
                console.log('reportBug:', error);
              }
            },
            function(error) {
              console.log('reportBug:', error);
            }
          )
        }
      },
      cancelAlert: function(alert){
        var index = alerts.indexOf(alert);
        alerts.splice(index,1)
      },
      clearAllAlerts: function() {
        alerts=[];
      },
      reportBug: function(alert){
        SiteVisitApi.reportBug(
          JSON.parse(localStorageService.get('visitor')), 
          JSON.parse(localStorageService.get('case')), 
          JSON.parse(localStorageService.get('position')), 
          platform.description, 
          alert.message, 
          alert.appModule, 
          localStorageService.get('appName'), 
          localStorageService.get('appVersion')).then(
          function(data) {
            try {
              switch (data.status) {
                case 'OK':
                  console.log('reportBug:', data);
                  alert.bugFiled = true;
                  break;
                default:
                  console.log('reportBug:', data);
              }
            } catch(error) {
              console.log('reportBug:', error);
            }
          },
          function(error) {
            console.log('reportBug:', error);
          }
        )
      },
      clearLocalCache: function(alert) {
        console.log({clearLocalCache: alert})
        localStorageService.clearAll();
        delete alert.message
      },
    };
  }]);
};